var _rect, _path, _path2, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmericanexpress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16,
    rx: 2,
    fill: "#016FD0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.76 11.6235V13.4644H21.4671L20.6197 12.4536L19.7391 13.4644H13.2258V8.0828H11.0769L13.7631 1.88232H16.3772L17.0086 3.28844V1.88232H20.2541L20.7969 3.35621L21.3286 1.88232H23.76V2.75761H21.8824L21.0295 5.05033L20.8025 5.67149L19.7114 2.75761H17.8338V7.27525L15.8843 2.75761H14.3723L12.4117 7.27525H13.6966L14.04 6.40562H16.1889L16.5323 7.27525H17.8338H18.9637V4.33315L18.9581 3.7402L19.1797 4.33315L20.2597 7.27525H21.3341L22.4197 4.33315L22.6301 3.74585V7.27525H23.76V9.04279L22.5083 10.3247L23.76 11.6235ZM14.1341 12.5891V8.08841H17.8338V9.06538H15.264V9.85596H17.784V10.8273H15.264V11.6122H17.8338V12.5891H14.1341ZM23.4166 12.5891H21.9489L20.6086 11.1209L19.2628 12.5891H17.8338L19.8997 10.3473L17.8338 8.08841H19.3071L20.6363 9.55103L21.9711 8.08841H23.4166L21.3452 10.3303L23.4166 12.5891Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1144 3.72326L14.8929 4.28798L14.4332 5.42866H15.7957L15.336 4.28798L15.1144 3.72326Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 15,
    rx: 1.5,
    stroke: "black",
    strokeOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmericanexpress);
export default __webpack_public_path__ + "static/media/americanexpress.069a7dbcd253eadab55ec077519ef878.svg";
export { ForwardRef as ReactComponent };